// extracted by mini-css-extract-plugin
export default {"container":"About_container__hDUxj","imgContainer":"About_imgContainer__pEmrx","img":"About_img__3BRJC","text":"About_text__uIKDX"};